module.exports = __webpack_public_path__ + "static/media/burger.37100135.png";